import { PersonalDataDetails } from '@/Domain/Entities';
import { InscriptionModules } from '@/Domain/enum';
import MasterDataService from '@/Services/MasterDataService';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Gender } from '@/Domain/enum';
import moment from 'moment';
import { MdSelect, MdDatepicker, MdRadio } from '@/Components';
import { State } from 'vuex-class';

@Component({
    name: 'personal-data-section',
    components: { MdSelect, MdDatepicker, MdRadio }
})
export default class PersonalDataSection extends Vue {
    @Prop() readonly isEditMode!: boolean;
    @Prop() readonly isDraftMode!: boolean;
    @Prop() readonly isAdminRole!: boolean;
    @Prop() readonly isAnyModuleEditing!: boolean;
    @Prop() readonly personalDataDetails!: PersonalDataDetails;
    @State('canChangeInscriptionDni', { namespace: 'featureFlagsStore' }) canChangeInscriptionDni!: boolean;

    get isDniDisabled() {
        return !this.canChangeInscriptionDni || !this.isEditMode;
    }

    Gender = Gender;
    maxRetirementAge: moment.Moment = moment().subtract(70, 'years').add(1, 'day');
    minUnderSixteen: moment.Moment = moment().subtract(16, 'years');
    nationalities: Array<{ name: string; id: string }> = [];

    $refs!: {
        dataPersonal: HTMLElement;
    };

    get underSixteen() {
        return this.personalDataDetails.dateOfBirth ?
            this.personalDataDetails.isAgeBelowMinimum() && (this.isDraftMode || this.isEditMode)
            : false;
    }

    get retirementAge() {
        return this.personalDataDetails.dateOfBirth ?
            this.personalDataDetails.isAgeAboveMaximum() && (this.isDraftMode || this.isEditMode)
            : false;
    }

    get personalDataFieldMappings() {
        return {
            NAME: 'name',
            FIRST_SURNAME: 'firstSurname',
            SECOND_SURNAME: 'secondSurname',
            NIF: 'nif',
            NATIONALITY_CODE: 'nationalityCode',
            DATE_OF_BIRTH: 'dateOfBirth',
            GENDER: 'gender'
        };
    }

    setEditMode() {
        this.$emit('setEditMode', InscriptionModules.enum.PERSONALDATA);
    }

    onSaveEditedPersonalData() {
        this.$emit('edit', InscriptionModules.enum.PERSONALDATA, this.$refs.dataPersonal);
    }

    cancelEditMode() {
        this.$emit('cancelEdit', InscriptionModules.enum.PERSONALDATA);
    }

    onChangePersonalData(field: string, value: any) {
        this.$emit('update:personalDataDetails', new PersonalDataDetails(
            {
                ...this.personalDataDetails.toServerInscription(),
                [field]: value
            }));
    }

    async getNationalities() {
        try {
            const response = await MasterDataService.getNationalitiesAsync();
            this.nationalities = response.map(element => ({ name: element.value, id: element.key }));
        } catch (error) {
            console.error(error);
        }
    }

    async created() {
        await this.getNationalities();
    }
}
